(() => {
    class Base {
        set(name, value = null) {
            if (value === null && typeof name === 'object') {
                for (let key in name) if (this[key] !== undefined) this[key] = name[key];
            } else {
                this[name] = value;
            }
            return this;
        }

        get(key) {
            return this[key];
        }

        objectify() {
            let values = {};
            for (let key in this) {
                if (key.startsWith('_')) {
                    values[key.replace('_', '')] = this[key];
                } else {
                    values[key] = this[key];
                }
            }
            return values;
        }

        merge(vars) {
            for (var key in vars) {
                if (this[key]) {
                    this[key] = vars[key];
                }
            }
            return this;
        }
    }
    App.Entities.Base = Base;
})();
